export default "__VITE_ASSET__DPSm_r6H__";